import { frontendURL } from '../../../../helper/URLHelper';
const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/connectivity-hub'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsContent,
      props: {
        headerTitle: 'SIDEBAR.CONNECTIVITY_HUB',
        icon: 'chatlyn-automations',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'settings_connectivity_hub',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
